import { T_FAQ_PAGE_CONSTANTS } from './TYPES'

const HU_FAQ_PAGE_CONSTANTS: T_FAQ_PAGE_CONSTANTS = {
  PAGE_KICKER: 'SEGÍTS MAGADON',
  PAGE_TITLE: 'Gyakran Ismételt Kérdések',
  FAQ_CATEGORIES: [
    {
      categoryName: 'Általános',
      faqs: [
        {
          question: 'Mi a célja ennek az alkalmazásnak? ',
          answer:
            'Ez az alkalmazás játékos és élményalapú módon ösztönzi a gyerekeket az olvasásra. A gyerekek - akiket az alkalmazás „kalandoroknak” nevez - offline olvasnak könyveket, majd a platformon kitöltik a könyvekhez kapcsolódó kvízeket. Ezzel pontokat szereznek, amelyek segítenek kabalájuknak, Griffynek – egy griffmadár-fiókának – szintet lépni és fejlődni, így az olvasás élménye még szórakoztatóbbá és jutalmazóbbá válik. Az alkalmazás különbséget tesz gyermek és felnőtt felhasználók között. A kalandorok játszhatnak egyedül, csatlakozhatnak olvasási eseményekhez vagy versenyekhez, és barátokat is hozzáadhatnak barátlistájukhoz. Megnézhetik egymás személyes könyvtárait is, ami elősegíti a könyvcserét és közösségi élményt teremt az olvasás köré. A felnőtt felhasználók kvízeket tölthetnek fel a platformra, valamint olvasási eseményeket vagy versenyeket szervezhetnek a gyermekek számára. Ez az együttműködésen alapuló rendszer támogatja a vezetett és az önálló olvasást is, így az alkalmazás sokoldalú eszközzé válik az olvasás iránti tartós szeretet kialakításához.'
        },
        {
          question: 'Ki használhatja ezt az alkalmazást?',
          answer:
            'Az alkalmazást felnőttek és gyerekek ("kalandorok") egyaránt használhatják.'
        },
        {
          question: 'Mit tehet egy felnőtt a platformon?',
          answer:
            'A felnőttek - szülők, tanárok - kvízeket tölthetnek fel, amelyek segítenek bővíteni a platform kvízadatbázisát. A felnőttek olvasási versenyeket és eseményeket is létrehozhatnak egy adott gyerekcsoport számára, hogy ösztönözzék az olvasást, miközben nyomon követik a gyerekek előrehaladását és eredményeit.'
        },
        {
          question: 'Mit tehet egy gyermek a platformon?',
          answer:
            'A gyerekek kvízeket tölthetnek ki, értékelhetik és nyomon követhetik könyveiket, kezelhetik könyvtárukat és kapcsolatba léphetnek a barátaikkal. Három játékmódban vehetnek részt: egyéni kaland, meghívásos versenyek és nyilvános események.'
        },
        {
          question:
            'Hogyan hozhatok létre fiókot magamnak és a gyermekem(nek)?',
          answer:
            'Teljes nevének, születési dátumának, előnyben részesített nyelvének, e-mail címének és egy 6 számjegyből álló jelszónak a megadásával fiókot hozhat létre. Miután létrehozta saját fiókját, a „Gyermek hozzáadása” gombra kattintva létrehozhatja gyermeke(i) fiókját a teljes név, születési dátum, előnyben részesített nyelv, felhasználónév és egy 6 számjegyű jelszó megadásával.'
        }
      ]
    },
    {
      categoryName: 'Fiók és előfizetés',
      faqs: [
        {
          question: 'Van előfizetési díj?',
          answer:
            'A platform felnőttek számára ingyenes. A platform gyermekek általi használata előfizetési díjhoz kötött. Többféle előfizetési csomag közül lehet választani, attól függően, hogy az előfizető hány gyermeket szeretne regisztrálni és milyen hosszú előfizetést szeretne. A fizetés PayPal-on keresztül történik. A platform a béta tesztelési időszak alatt díjmentesen használható.'
        },
        {
          question: 'Kipróbálhatja a gyermekem a platformot ingyenesen?',
          answer:
            'Igen, a gyermekek számára egy 15 napos próbaidőszak áll rendelkezésre. Ennek leteltét követően egy felnőttnek elő kell fizetnie a gyermeket egy előfizetési csomagra.'
        },
        {
          question: 'Milyen előnyei vannak az előfizetésnek?',
          answer:
            'Az előfizetés a platform összes funkcióját biztosítja, beleértve a versenyeken való részvételt, a ranglisták megtekintését és a legjobb helyezésekért járó jelvények megszerzését.'
        }
      ]
    },
    {
      categoryName: 'Játékmenet és funkciók',
      faqs: [
        {
          question: 'Mik azok a kvízek?',
          answer:
            'A kvízek az offline olvasott könyv szövegének megértését célzó feleletválasztós tesztek, amelyek 5 kérdésből állnak. Minden kérdéshez három válaszopció tartozik, egy helyes és két helytelen. A helyes válasz kiválasztásával pontok szerezhetők (kérdésenként 5 pont, vagyis kvízenként maximum 25 pont), amelyek hozzájárulnak a karakter tapasztalati pontjaihoz, ami szintlépéshez és Griffy kabalafigurájának fejlődéséhez vezet.'
        },
        {
          question: 'Versenyezhetnek a gyerekek egymással?',
          answer:
            'Igen, a felnőttek versenyeket hozhatnak létre a gyerekek számára. A ranglistán megjelennek a helyezések, és a legjobb helyezettek jelvényeket kapnak. A gyerekek a platform által szervezett eseményeken is versenyezhetnek.'
        },
        {
          question: 'Hogyan barátkozhatnak a gyerekek a platformon?',
          answer:
            'A gyerekek hozzáadhatnak más gyerekeket a barátlistájukhoz. Megtekinthetik barátaik könyveit is, hogy elősegítsék az offline kapcsolatot és beszélgetéseket.'
        }
      ]
    },
    {
      categoryName: 'Könyv és olvasás',
      faqs: [
        {
          question:
            'Megadhatják a gyerekek az alkalmazásban, hogy mely könyveik vannak meg?',
          answer:
            'A gyerekek az alkalmazás „Könyvtáram” részében megjelölhetik az otthoni könyvtárukban  elérhető könyveket. Így a barátaik is láthatják, milyen könyveik vannak, és így adott esetben könyvek kölcsönzésében állapodhatnak meg egymás között.'
        },
        {
          question: 'A gyerekek a könyveket az alkalmazáson belül olvassák?',
          answer:
            'Nem, az alkalmazás nem tartalmaz könyveket, csak az azokhoz kapcsolódó kvízeket. A gyerekek offline olvassák el a könyveket, majd az alkalmazásban kitöltik a hozzájuk tartozó kvízeket.'
        }
      ]
    },
    {
      categoryName: 'Technikai támogatás',
      faqs: [
        {
          question: 'Elfelejtettem a felhasználónevemet. Mit tegyek?',
          answer:
            'A bejelentkezési oldalon kattintson az oldal alján az "Elfelejtetted a felhasználónevedet vagy jelszavadat?" gombra és kövesse az utasításokat.'
        },
        {
          question: 'Elfelejtettem a jelszavamat. Mit tegyek?',
          answer:
            'A bejelentkezési oldalon kattintson az oldal alján az "Elfelejtetted a felhasználónevedet vagy jelszavadat?" gombra és kövesse az utasításokat.'
        },
        {
          question: 'Hogyan léphetek kapcsolatba az ügyfélszolgálattal?',
          answer:
            'Bármilyen probléma vagy kérdés esetén kapcsolatba léphet ügyfélszolgálatunkkal az alkalmazás súgó részén keresztül vagy e-mailben a contact@griffyreads.com címen.'
        }
      ]
    }
  ]
}

export default HU_FAQ_PAGE_CONSTANTS
